import React, { useState } from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import queryString from 'query-string';

import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Popover from '@material-ui/core/Popover';
import Tooltip from '@material-ui/core/Tooltip';

import classes from './ViewSelector.module.css';

const EnergyViewSelector = ({
    activeNavSite,
    history,
    view,
    handleChangeView,
    ...props
}) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const open = Boolean(anchorEl);
    const id = open ? 'nav-select-popover' : undefined;

    const queryValues = queryString.parse(history.location.search);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(!menuOpen);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setMenuOpen(false);
    };

    const handleSelect = view => {
        handleChangeView(view);
        setAnchorEl(null);
        setMenuOpen(false);
    };

    const renderListOptions = () => {
        switch (queryValues.parentId) {
            case '219ac5b7-d588-425d-a2ca-d2f0d92586ab':
                return (
                    <List>
                        <ListItem
                            key={0}
                            onClick={() => handleSelect('Client Site Grid')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Client Site Grid
                        </ListItem>
                        <ListItem
                            key={1}
                            onClick={() => handleSelect('Client Equipment Grid')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Client Equipment Grid
                        </ListItem>
                    </List>
                );
            case 'bac0591c-03e4-4929-b71d-2f3e3d3e4719':
                return (
                    <List>
                        <ListItem
                            key={0}
                            onClick={() => handleSelect('Site Power Grid')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Site Power Grid
                        </ListItem>
                        <ListItem
                            key={1}
                            onClick={() => handleSelect('Site Power Graph')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Site Power Graph
                        </ListItem>
                        <ListItem
                            key={2}
                            onClick={() => handleSelect('Site Heat Map')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Site Heat Map
                        </ListItem>
                        <ListItem
                            key={3}
                            onClick={() => handleSelect('Site Equipment Grid')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Equipment Grid
                        </ListItem>
                        <ListItem
                            key={4}
                            onClick={() => handleSelect('Site Avoided Costs Graph')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Avoided Costs Graph
                        </ListItem>
                        <ListItem
                            key={5}
                            onClick={() => handleSelect('Site Future Savings Graph')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Future Savings Graph
                        </ListItem>
                    </List>
                );
            case '16cc471d-a182-421d-bb2a-eb9560939c53':
                return (
                    <List>
                        <ListItem
                            key={0}
                            onClick={() => handleSelect('Equipment Power Grid')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Equipment Power Grid
                        </ListItem>
                        <ListItem
                            key={1}
                            onClick={() => handleSelect('Equipment Power Graph')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Equipment Power Graph
                        </ListItem>
                        <ListItem
                            key={2}
                            onClick={() => handleSelect('Equipment Heat Map')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Equipment Heat Map
                        </ListItem>
                        <ListItem
                            key={3}
                            onClick={() => handleSelect('Equipment Avoided Costs Graph')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Avoided Costs Graph
                        </ListItem>
                        <ListItem
                            key={4}
                            onClick={() => handleSelect('Equipment Future Savings Graph')}
                            classes={{
                                root: classes.EnergyListItem
                            }}
                        >
                            Future Savings Graph
                        </ListItem>
                    </List>
                );
            default:
                return;
        }
    };

    return (
        <div>
            <Button
                className={classes.Button}
                aria-describedby={id}
                onClick={handleClick}
            >
                <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    title="view"
                    placement="bottom"
                >
                    <div className={classes.Selector}>
                        <p>View - {view} <i className={`fas fa-chevron-${menuOpen ? 'down' : 'up'}`} aria-hidden="true" /></p>
                    </div>
                </Tooltip>
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical:   'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical:   'top',
                    horizontal: 'left',
                }}
            >
                <div>
                    {renderListOptions()}
                </div>
            </Popover>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavSite: state.bob.activeNavSite
    };
};

export default withRouter(connect(mapStateToProps, null)(EnergyViewSelector));
